module.exports = __webpack_public_path__ + "img/meal.d5ba0a6e.png";